import { Modal } from "~/ui/common";

interface DeleteAllConfirmDialogProps {
  show: boolean;
  rulesCount: number;
  isLoading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeleteAllConfirmDialog = ({
  show,
  rulesCount,
  isLoading,
  onConfirm,
  onClose,
}: DeleteAllConfirmDialogProps) => (
  <Modal
    show={show}
    title="Delete global rules"
    onClose={onClose}
    handleConfirm={onConfirm}
    confirmLabel="Yes, delete them"
    closeLabel="Cancel"
    isLoading={isLoading}
  >
    <p className="text-lg text-neutral-600">
      This will remove {rulesCount} global block rule
      {rulesCount !== 1 ? "s" : ""} and every provider exception attached to
      them. Providers blocked by these rules become available again. This action
      cannot be undone.
    </p>
  </Modal>
);
